import "../App.css";

export function TermsOfSale(props) {
  return (
    <div
      className="App"
      style={{
        backgroundColor: "#131313",
        color: "white",
        overflowY: "scroll",
        height: "100vh",
      }}
    >
      <header>
        <h1>
          SALGS-
          <br />
          BETINGELSER
        </h1>
      </header>

      <article>
        <section>
          <h1 id="introduction">1. Parter</h1>

          <p>
            Dette er salgsbetingelsene for kjøp av digitale varer og
            abonnementstjenester på www.fyl.la, levert av MAFE Studios DA, et
            norsk ansvarlig selskap med delt ansvar (org.nr. 935 242 045),
            heretter kalt “oss”, “vi” eller “selger”. Kjøperen er deg, brukeren
            som kjøper en digital vare eller tegner et abonnement via tjenesten,
            heretter kalt “deg” eller “brukeren”.
          </p>
        </section>

        <section>
          <h1 id="what-do-we-sell">2. Hva selger vi?</h1>

          <p>Vi tilbyr følgende digitale varer og tjenester på Fyl.la:</p>
          <ul style={{ listStyleType: "square", fontSize: "1.2rem" }}>
            <li>
              Enkeltkjøp: “Fortsett rom med AI”: En digital engangstjeneste som
              lar deg generere videre på rommet ditt på vår plattform. Tjenesten
              leveres umiddelbart i spillet.
            </li>
            <li>
              Abonnement: “FYL.LA Premium”: Et månedlig abonnement som gir deg
              tilgang til ett premium-rom med AI-generert innhold basert på dine
              innstillinger, så lenge abonnementet er aktivt. Du beholder også
              muligheten til å legge inn innhold som i klassiske rom.
            </li>
          </ul>
        </section>

        <section>
          <h1 id="payment">3. Alderskrav</h1>

          <p>
            Du må være minst 18 år for å gjennomføre kjøp eller tegne abonnement
            på Fyl.la. For abonnementstjenesten (“FYL.LA Premium”) håndheves
            dette kravet av Vipps MobilePay ved inngåelse av betalingsavtalen.
          </p>
        </section>

        <section>
          <h1 id="payment">4. Betaling</h1>
          <ul style={{ listStyleType: "square", fontSize: "1.2rem" }}>
            <li>
              {" "}
              Enkeltkjøp: Betaling skjer via Vipps. Prisen for “fortsett rom med
              AI” vises tydelig før kjøpet. Betalingen trekkes én gang når du
              bekrefter kjøpet.
            </li>
            <li>
              Abonnement (“FYL.LA Premium”): Betaling skjer via Vipps faste
              betalinger (Vipps Recurring). Ved tegning av abonnement inngår du
              en betalingsavtale med oss gjennom Vipps MobilePay.
              <ul>
                <li>
                  Prøveperiode: Abonnementet starter med en gratis prøveperiode
                  på 14 dager. Du belastes ikke i prøveperioden.
                </li>
                <li>
                  Månedlig betaling: Etter prøveperioden belastes du 69 kr per
                  måned. Beløpet trekkes automatisk via din
                  Vipps-betalingsavtale.
                </li>
                <li>
                  Maksbeløp: Maksimalt belastningsbeløp per måned er 69 kr.
                </li>
              </ul>
            </li>
          </ul>
          <p>
            Alle priser er oppgitt i norske kroner (NOK) og inkluderer
            merverdiavgift der dette er pålagt.
          </p>
        </section>

        <section>
          <h1 id="payment">5. Prisendringer</h1>
          <p>
            Vi forbeholder oss retten til å endre abonnementsprisen. Ved
            prisendringer vil du bli varslet via SMS til mobilnummeret knyttet
            til din Vipps-betalingsavtale, minst 30 dager før endringen trer i
            kraft. Din betalingsavtale i Vipps-appen vil også oppdateres med den
            nye prisen. Du kan når som helst si opp abonnementet dersom du ikke
            aksepterer den nye prisen.
          </p>
        </section>

        <section>
          <h1 id="what-do-we-sell">6. Levering</h1>

          <ul style={{ listStyleType: "square", fontSize: "1.2rem" }}>
            <li>
              Enkeltkjøp: Den digitale varen (“fortsett rom med AI”) leveres
              umiddelbart etter at betalingen er bekreftet av Vipps. Du får
              tilgang til det utvidede rommet i spillet ditt. Hvis du mister
              koblingen, kan du finne tilbake til det med din rom-ID.
            </li>
            <li>
              Abonnement: Tilgang til ditt premium-rom aktiveres umiddelbart
              etter at betalingsavtalen er godkjent i Vipps. Tilgangen
              opprettholdes så lenge abonnementet er aktivt.
            </li>
          </ul>
        </section>

        <section>
          <h1 id="payment">7. Angrerett</h1>
          <p>
            Under norsk lov (angrerettloven) har du normalt 14 dagers angrerett
            på fjernsalg.
          </p>
          <ul style={{ listStyleType: "square", fontSize: "1.2rem" }}>
            <li>
              Enkeltkjøp: For digitale varer som leveres umiddelbart og ikke på
              et fysisk medium, kan angreretten bortfalle dersom du samtykker
              til det. Ved å kjøpe “fortsett rom med AI” og bekrefte kjøpet,
              samtykker du til umiddelbar levering og godtar at du mister
              angreretten når leveringen starter. Dette skjer når du klikker
              “Kjøp med Vipps”. Denne informasjonen vises tydelig på kjøpssiden
              før du fullfører betalingen.
            </li>
            <li>
              Abonnement: Du kan si opp abonnementet når som helst i løpet av
              prøveperioden på 14 dager uten kostnad, via Vipps-appen under dine
              faste betalinger. Dersom du sier opp i prøveperioden, vil du ikke
              bli belastet. Etter prøveperioden gjelder oppsigelsesvilkårene i
              punkt 8.
            </li>
          </ul>
        </section>

        <section>
          <h1 id="payment">8. Administrasjon og oppsigelse av abonnement</h1>

          <p>
            Du kan administrere abonnementet ditt via Vipps-appen under dine
            faste betalinger. Derfra kan du:
          </p>

          <ul style={{ listStyleType: "square", fontSize: "1.2rem" }}>
            <li>
              Si opp abonnementet: Du kan når som helst si opp ditt “FYL.LA
              Premium”-abonnement. Ved oppsigelse beholder du tilgang til ditt
              premium-rom ut den inneværende betalingsperioden. Etter periodens
              utløp avsluttes tilgangen.
            </li>
            <li>
              Endre rom-ID: Via lenken i din betalingsavtale i Vipps kan du når
              som helst endre rom-ID-en knyttet til ditt premium-rom.
            </li>
          </ul>
        </section>
      </article>

      <section>
        <h1 id="payment">9. Retur og refusjon</h1>

        <ul style={{ listStyleType: "square", fontSize: "1.2rem" }}>
          <li>
            Enkeltkjøp: Siden “fortsett rom med AI” er en digital vare som
            leveres umiddelbart og integreres i spillet ditt, er det ikke mulig
            å returnere den etter levering.
          </li>
          <li>
            Abonnement: Allerede betalte abonnementsperioder refunderes ikke.
            Ved oppsigelse beholder du tilgang ut inneværende periode.
          </li>
        </ul>
      </section>

      <section>
        <h1 id="payment">10. Klager</h1>

        <p>
          Hvis noe går galt (f.eks. betaling trekkes uten at tjenesten leveres),
          kan du kontakte oss på fyl.la.contact@gmail.com. Inkluder detaljer om
          kjøpet ditt (f.eks. rom-ID eller tidspunkt for transaksjonen). Vi
          svarer på henvendelser innen 14 dager og jobber for å løse problemet
          raskt.
        </p>
      </section>

      <section>
        <h1 id="payment">11. Sikkerhet og personopplysninger</h1>

        <p>
          Betalingsinformasjonen din håndteres av Vipps MobilePay. Vi lagrer
          ikke kortdetaljer eller betalingsinformasjon selv. For
          abonnementstjenesten behandler vi ditt mobilnummer i forbindelse med
          betalingsavtalen og eventuell kommunikasjon om abonnementet (f.eks.
          prisendringer). For mer informasjon om hvordan vi behandler dataene
          dine, se vår personvernerklæring på{" "}
          <a href="/privacy-policy">fyl.la/privacy-policy</a>.
        </p>
      </section>
      <section>
        <h1 id="payment">12. Konfliktløsning</h1>

        <p>
          Disse salgsbetingelsene er underlagt norsk lov. Hvis vi ikke kan løse
          en tvist direkte, kan du ta kontakt med Forbrukertilsynet for
          veiledning. Du har også rett til å bringe saken inn for norske
          domstoler.
        </p>
      </section>
      <section>
        <h1 id="payment">13. Kontaktinformasjon</h1>

        <ul style={{ listStyleType: "square", fontSize: "1.2rem" }}>
          <li>Selger: MAFE Studios DA</li>
          <li>Organisasjonsnummer: 935 242 045</li>
          <li>
            E-post:{" "}
            <a href="mailto:mafestudios.contact@gmail.com">
              mafestudios.contact@gmail.com
            </a>
          </li>
        </ul>
      </section>
      <br></br>
    </div>
  );
}
